var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.mergedClass, style: _vm.mergedStyle }, [
    _c(
      "table",
      {
        staticClass: "w-100 h-100",
        class: _vm.tableClass,
        style: _vm.tableStyle
      },
      [
        _c(
          "tbody",
          _vm._l(_vm.groupedAssignments, function([email, assignments]) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(email))]),
              _vm._v(" "),
              _c(
                "td",
                _vm._l(assignments, function(assignment) {
                  return _c("div", [
                    _vm._v(" " + _vm._s(_vm.formatAssignment(assignment)))
                  ])
                }),
                0
              )
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }